import { inject, Injectable } from '@angular/core';
import { EasyValidityTypeCode, From } from '@easy-lib/modules/order/oms/models/orderModels.model';
import { IBaseOMSOrder } from '@easy-lib/modules/order/oms/models/base-order.model';
import { UserDeviceService } from '@easy-lib/modules/shared/services/user-device.service';
import { DeviceTypeEnum } from '@easy-lib/modules/account-activity/models/accountDto';
import { DraftOrder } from '@easy-lib/modules/order/oms/models/draft-order.model';
import { SymbolService } from '@easy-lib/modules/shared/services';
import { isOptionSymbol } from '../../../../tools/symbol-helper-tool';

@Injectable({
	providedIn: 'root'
})
export class OrderSending {
	public userDeviceService: UserDeviceService;
	private symbolService = inject(SymbolService);

	constructor() {
		this.userDeviceService = inject(UserDeviceService);
	}
	prepareSendingOrder(order: IBaseOMSOrder): IBaseOMSOrder {
		const { marketUnit } = this.symbolService.symbolByIsin[order.symbolIsin];
		return {
			symbolIsin: order.symbolIsin,
			price: order.price,
			quantity: order.quantity,
			side: order.side,
			validityType:
				[EasyValidityTypeCode.Month, EasyValidityTypeCode.Week].indexOf(order.validityType) >= 0
					? EasyValidityTypeCode.ValidToDate
					: order.validityType,
			validityDate: order.validityDate,
			orderFrom:
				this.userDeviceService.deviceType === DeviceTypeEnum.Desktop
					? !isOptionSymbol(marketUnit)
						? From.OrbisDesktop
						: From.OrbisOptionDesktop
					: !isOptionSymbol(marketUnit)
						? From.OrbisMobile
						: From.OrbisOptionMobile
		} as IBaseOMSOrder;
	}
	prepareSendingDraft(draft: DraftOrder, isCreate: boolean): IBaseOMSOrder {
		const data = {
			symbolIsin: draft.symbolIsin,
			symbolName: draft.symbolName,
			price: draft.price,
			quantity: draft.quantity,
			side: draft.side,
			validityType:
				[EasyValidityTypeCode.Month, EasyValidityTypeCode.Week].indexOf(draft.validityType) >= 0
					? EasyValidityTypeCode.ValidToDate
					: draft.validityType,
			validityDate: null,
			cautionAgreementSelected: draft.cautionAgreementSelected
		} as DraftOrder;

		if (!isCreate) data.id = draft.id;
		return data;
	}
}
